module.exports = __webpack_public_path__ + "img/kongres3.b4814703.jpg";